import { render, staticRenderFns } from "./colorSelect.vue?vue&type=template&id=fea58500&scoped=true"
import script from "./colorSelect.vue?vue&type=script&lang=js"
export * from "./colorSelect.vue?vue&type=script&lang=js"
import style0 from "./colorSelect.vue?vue&type=style&index=0&id=fea58500&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fea58500",
  null
  
)

export default component.exports